export const mobileBreakpoint = {
  width: 768,
}

export const media = {
  mobile: `@media only screen and (max-width: ${mobileBreakpoint.width - 1}px)`,
  desktop: `@media only screen and (min-width: ${mobileBreakpoint.width}px)`,
}
